/**
 * Fire-and-forget activity logger.
 * Sends button press to the server for logging.
 * Silently fails — never blocks the UI.
 *
 * @param {string} action - Button / action name, e.g. "Check Duplicates"
 */
export const logAction = (action) => {
  try {
    const user = localStorage.getItem("username") || "Anonymous";
    fetch("/api/log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action, user }),
    }).catch(() => {}); // silently ignore network errors
  } catch {
    // ignore
  }
};
